import React from "react";
import SounargreiningPage from "@components/Pages/SounargreiningPage/SounargreiningPage";

export default function Software() {
    return <SounargreiningPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
